module.exports = __webpack_public_path__ + "static/img/xnkl.914125a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/xnkl.png
// module id = jk44
// module chunks = 0